
export default {
  props: {
    document: {
      type: Object,
      default: undefined,
      required: false
    },
    primary: {
      type: Boolean,
      required: false
    },

    preview: {
      type: Boolean,
      required: false
    },

    matches: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    fileName () {
      if (this.document.type === 'LINK') { return this.document.filePath; }

      return this.document.fileName.replace(this.document.extension, '');
    },

    fileType () {
      if (this.document.type === 'LINK') {
        return 'link';
      }

      return this.document.extension.trim().substring(1).toLowerCase();
    },

    canOpen () {
      return (
        !this.preview &&
        this.document.type !== 'LINK' &&
        this.document.extension === '.pdf'
      );
    },

    documentUrl () {
      if (this.document.filePath.startsWith('http')) {
        return this.document.filePath;
      }

      return (
        this.$config.publicStorageBaseUrl.replace(/^\/+|\/+$/g, '') +
        '/' +
        this.document.filePath
      );
    }
  },

  methods: {
    open () {
      if (this.preview) {
        return;
      }

      if (this.canOpen && this.$device.isDesktop) {
        return this.openPdf();
      }
      this.download();
    },

    openPdf (match) {
      if (!this.canOpen) {
        this.download();
        return;
      }
      this.$emit('open', {
        url: this.documentUrl,
        match,
        name: this.document.fileName
      });
    },

    download () {
      window.open(this.documentUrl, '_blank');
    }
  }
};
